$(document).ready(() => {
  $('.hpe-video')
    .find('img')
    .click(function () {
      const $img = $(this).parents('.hpe-video__poster');
      const $wrapper = $img.parents('.hpe-video');
      const $video = $wrapper.find('.hpe-video__player');

      $img.hide();
      $video.get(0).play();
    });
});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/video.js